import React from 'react'

import PropTypes from 'prop-types'

const MarkdownWrapper = ({children}) => <div className="mt-MarkdownWrapper">{children}</div>

MarkdownWrapper.displayName = 'MarkdownWrapper'

MarkdownWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export default MarkdownWrapper
